import Swiper from 'swiper/bundle';
import { updateSlidesInert } from '../utils/accessibility-swiper';

const syncSlidesInert = (swiper) => {
  window.requestAnimationFrame(() => {
    updateSlidesInert(swiper, 'visible');
  });
};

export function initTestDriveSlider() {
  const sliderEl = document.querySelector('.test-drive-page__cards-slider');
  if (!sliderEl) return;

  // Проверяем, что мы на мобильной версии (md breakpoint = 768px)
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (!isMobile) return; // Не инициализируем слайдер на десктопе

  const AUTOPLAY_DELAY = 5000; // 5s
  let lastActiveIndex = 0;
  const locale = window.Shopify?.locale || 'uk';
  const getAutoplayLabel = isPlaying => (
    locale === 'ru'
      ? (isPlaying ? 'Остановить воспроизведение' : 'Запустить воспроизведение')
      : (isPlaying ? 'Зупинити програвання' : 'Запустити програвання')
  );

  const testDriveSlider = new Swiper(sliderEl, {
    slidesPerView: 'auto',
    spaceBetween: 12,
    watchSlidesProgress: true,
    autoplay: {
      delay: AUTOPLAY_DELAY,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.test-drive-page__pagination',
      clickable: true,
    },
    a11y: {
      enabled: true,
      slideLabelMessage: '',
      paginationBulletMessage:
        Shopify.locale === 'uk'
          ? 'Перейти до слайду {{index}}'
          : 'Перейти к слайду {{index}}',
      nextSlideMessage:
        Shopify.locale === 'uk' ? 'Наступний слайд' : 'Следующий слайд',
      prevSlideMessage:
        Shopify.locale === 'uk' ? 'Попередній слайд' : 'Предыдущий слайд',
    },
    on: {
      init(swiper) {
        setTimeout(() => {
          swiper.slides.forEach(slide => {
            slide.removeAttribute('role');
          });
        }, 0);

        lastActiveIndex = swiper.snapIndex;
        syncSlidesInert(swiper);
      },

      slideChange(swiper) {
        const bullets = swiper.pagination.bullets;
        // скидаємо прогрес у попереднього булета
        if (bullets[lastActiveIndex]) {
          bullets[lastActiveIndex].style.setProperty('--progress', 0);
        }
        lastActiveIndex = swiper.snapIndex;
        syncSlidesInert(swiper);
      },

      transitionEnd(swiper) {
        syncSlidesInert(swiper);
      },

      resize(swiper) {
        syncSlidesInert(swiper);
      },

      // тут від Swiper отримуємо прогрес autoplay
      autoplayTimeLeft(swiper, time, progress) {
        const bullets = swiper.pagination.bullets;
        const activeBullet = bullets[swiper.snapIndex];
        if (!activeBullet) return;

        // progress: 0 → тільки почалося, 1 → зараз переключиться
        activeBullet.style.setProperty('--progress', 1 - progress);
      },
    },
  });

  // кнопка Play / Pause
  const autoplayToggleBtn = document.querySelector('.test-drive-page__button');

  if (autoplayToggleBtn) {
    autoplayToggleBtn.setAttribute('aria-label', getAutoplayLabel(true));

    autoplayToggleBtn.addEventListener('click', () => {
      if (!testDriveSlider.autoplay) return;

      if (testDriveSlider.autoplay.running) {
        testDriveSlider.autoplay.stop();
        autoplayToggleBtn.classList.add('is-paused');
        autoplayToggleBtn.setAttribute('aria-label', getAutoplayLabel(false));
      } else {
        testDriveSlider.autoplay.start();
        autoplayToggleBtn.classList.remove('is-paused');
        autoplayToggleBtn.setAttribute('aria-label', getAutoplayLabel(true));
      }
    });
  }
}
